var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 20,
    stroke: "white",
    strokeOpacity: 0.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.9986 27.0021V27.0016H27.0016V22.6006C27.0016 20.4476 26.5381 18.7891 24.0211 18.7891C22.8111 18.7891 21.9991 19.4531 21.6676 20.0826H21.6326V18.9901H19.2461V27.0016H21.7311V23.0346C21.7311 21.9901 21.9291 20.9801 23.2226 20.9801C24.4971 20.9801 24.5161 22.1721 24.5161 23.1016V27.0021H26.9986Z",
    fill: "#6683A5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1992 18.9883H17.6872V26.9998H15.1992V18.9883Z",
    fill: "#6683A5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.441 15C15.6455 15 15 15.6455 15 16.441C15 17.2365 15.6455 17.8955 16.441 17.8955C17.2365 17.8955 17.882 17.2365 17.882 16.441C17.8815 15.6455 17.236 15 16.441 15V15Z",
    fill: "#6683A5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/linkedIn.55bcba2a92ec09a86684e7c4ea6552a6.svg";
export { ForwardRef as ReactComponent };